import { useState } from 'react'
import OrgsManager from './OrgsManager'
import TeamsBrowser from './TeamsBrowser'
import PlayersBrowser from './PlayersBrowser'
import CsvUploader from './CsvUploader'

// Phase 1 tabs. "Settings" is reserved for a future tab when we add
// scrape scheduling, SportsEngine API auth, etc.
const TABS = [
  { id: 'orgs',    label: 'Orgs' },
  { id: 'teams',   label: 'Teams' },
  { id: 'players', label: 'Players' },
  { id: 'upload',  label: 'Upload CSV' },
]

export default function TeamsDataModule() {
  const [tab, setTab] = useState('orgs')

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <h2 style={{ marginBottom: 4 }}>Teams Data</h2>
        <p className="muted">
          Rosters, teams, and (future) game results / player stats / standings.
          Phase 1: CSV upload only — run scrapers locally and upload the output here.
        </p>
      </div>

      <div className="tab-bar" style={{
        display: 'flex', gap: 8, marginBottom: 16,
        borderBottom: '1px solid var(--border-color, #2a2a2a)',
        alignItems: 'center',
      }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            style={{
              padding: '8px 16px',
              background: 'transparent',
              border: 'none',
              borderBottom: tab === t.id ? '2px solid var(--accent, #4a90e2)' : '2px solid transparent',
              color: tab === t.id ? 'var(--text-primary, #fff)' : 'var(--text-muted, #888)',
              cursor: 'pointer',
              fontWeight: tab === t.id ? 600 : 400,
            }}>
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'orgs'    && <OrgsManager />}
      {tab === 'teams'   && <TeamsBrowser />}
      {tab === 'players' && <PlayersBrowser />}
      {tab === 'upload'  && <CsvUploader />}
    </div>
  )
}
